<template>
    <div :class="['slug-input', customClass]">
        <label class="label inline">{{ $c__('slug, URL', 'URL:') }}</label>
        <span class="domain" v-text="`${domainName}/`"></span><span class="inline-input" contenteditable="true" spellcheck="false" data-placeholder="Edit" v-text="slugValue" @keydown="onKeyDown" @input="onInput" ref="inlineInput"></span>
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'SlugInput',

        props: {
            customClass: String,
            inputId : {
                type: String,
                required: true
            },
            domainName : {
                type: String,
                required: true
            },
            slugValue : {
                type: String,
                required: true
            },
            bindId: String
        },

        data() {
            return {
                slugInput: {},
                slugInputValue: this.slugValue,
                slugRange: {
                    pos: 0,
                    end: 0
                },
                isBinded: false
            }
        },

        computed: {
            slugifiedSlugInputValue() {
                return this.slugify(this.slugInputValue);
            }
        },

        watch: {
            slugInputValue() {
                this.setInputValue(this.slugifiedSlugInputValue);
                this.setInlineInputValue(this.slugifiedSlugInputValue);
            }
        },

        mounted() {
            this.slugInput = this.$el.querySelector(`[name="${this.inputId}"]`);
            this.bind();
        },

        methods: {
            onKeyDown(e) {
                if (e.which === 13) {
                    e.preventDefault();
                }
            },

            onInput(e) {
                if (e.target.tagName.toLowerCase() == 'span') {
                    this.saveInlineInputRangePosition();
                    this.slugInputValue = e.target.textContent;
                    this.unbind();
                } else {
                    this.slugInputValue = e.target.value;
                }
            },

            setInputValue(value) {
                this.slugInput.value = value;
            },

            setInlineInputValue(value) {
                this.$refs.inlineInput.innerText = value;
                if (!this.isBinded) {
                    this.restoreInlineInputRangePosition();
                }
            },

            bind() {
                if (!this.slugValue && this.bindId) {
                    this.isBinded = true;
                    document.getElementById(this.bindId).addEventListener('input', this.onInput, false);
                }
            },

            unbind() {
                if (this.isBinded) {
                    document.getElementById(this.bindId).removeEventListener('input', this.onInput);
                    this.isBinded = false;
                }
            },

            slugify(value) {
                // This should be replaced in the future for the better language support
                var slugified = value.normalize('NFD').toLowerCase()
                    .replace(/[\u0300-\u036f]/g, "") // remove accents
                    .replace(/\s+/g, '-')            // replace spaces with -
                    .replace(/[^\w\-]+/g, '')        // remove all non-word chars
                    .replace(/\-\-+/g, '-')          // replace multiple - with single -
                    .replace(/^-+/, '')              // trim - from start of text

                return this.isBinded ? slugified.replace(/-+$/, '') // Trim - from end of text
                    : slugified;
            },

            saveInlineInputRangePosition() {
                if (this.$refs.inlineInput.childNodes[0]) {
                    var range = window.getSelection().getRangeAt(0);
                    this.slugRange.pos = range.startOffset;
                    this.slugRange.end = this.$refs.inlineInput.childNodes[0].length;
                }
            },

            restoreInlineInputRangePosition() {
                if (this.$refs.inlineInput.childNodes[0]) {
                    var sel = window.getSelection();
                    var slugNode = this.$refs.inlineInput.childNodes[0];
                    var offset = this.slugRange.pos - (this.slugRange.end - slugNode.length);
                    var range = new Range();
                    range.setStart(slugNode, offset <= slugNode.length ? offset : slugNode.length);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
    }
</script>
